import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import './index.scss';
import './components/DefinitionPopover/DefinitionPopover.css';
import { CookiesProvider } from 'react-cookie';
import { AuthProvider } from './auth/AuthContext';
import Router from './components/Router/Router';
import { UiProvider } from './context/UiContext';
import { isDev } from './utils/env-utils';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: console.error,
  }),
  defaultOptions: { queries: { staleTime: 1000 } },
});

const ApplicationRoutes = () => {
  const { pathname } = useLocation();
  const content = (
    <>
      <UiProvider>
        <Router />
      </UiProvider>
      {!!isDev && <ReactQueryDevtools initialIsOpen={false} />}
    </>
  );
  // public declaration links must not trigger tenant-switch sign-out
  return /^\/[^/]+\/(?:outofscope\/[^/]+|email-form\/[^/]+\/[^/]+)\/?$/.test(pathname) ? (
    content
  ) : (
    <AuthProvider>{content}</AuthProvider>
  );
};

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ApplicationRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>,
);
